import {Button, Container, Group, Text, Title} from '@mantine/core';
import {useNavigate} from '@tanstack/react-router';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Container size="md" py="xl">
      <Title order={1} ta="center" mb="md">404 - Page Not Found</Title>
      <Text c="dimmed" ta="center" mb="xl">
        The page you're looking for doesn't exist or has been moved.
      </Text>
      <Group justify="center">
        <Button onClick={() => navigate({ to: '/' })}>
          Return Home
        </Button>
      </Group>
    </Container>
  );
} 